// components/Statistics.tsx
import React, { useState } from 'react';
import { Row, Col, Card, Progress, Statistic, Select, Spin } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import SummaryCard from '../../../components/common/SummaryCard';
import { FiUsers, FiUserCheck, FiUserX, FiTrendingUp } from 'react-icons/fi';
import { TbSum } from 'react-icons/tb';
import { useGetMessageStats } from '../../../hooks/api/notification/notificationService';

const { Option } = Select;

const Statistics = () => {
  const [period, setPeriod] = useState('month');

  const { data: statsResponse, isLoading } = useGetMessageStats({ period });
  console.log("Stats Response:", statsResponse);
  
  // Extract data from the nested structure
  const statsData = statsResponse?.data;
  const totalMessages = statsData?.totalMessages;
  const deliveryRate = statsData?.deliveryRate;
  const totalCost = statsData?.totalCost;
  const activeTriggers = statsData?.activeTriggers;
  const channelDistribution = statsData?.channelDistribution;

  // Helper function to extract numeric value from strings
  const extractNumber = (value: string) => {
    if (!value) return 0;
    const num = parseFloat(value.replace(/[^0-9.]/g, ''));
    return isNaN(num) ? 0 : num;
  };

  // Mock user data - replace with actual API when available
  const summary = {
    dau: { value: 12543, change: { value: 8.2 } },
    wau: { value: 85642, change: { value: 12.5 } },
    mau: { value: 254823, change: { value: 5.8 } },
    bounceRate: { value: 32.4, change: { value: -2.1 } },
    avgSessionDuration: { value: 4.2, change: { value: 0.3 } },
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="mt-6">
      {/* Period Selector */}
      <div className="flex justify-end mb-4">
        <Select
          value={period}
          onChange={setPeriod}
          style={{ width: 120 }}
        >
          <Option value="day">Today</Option>
          <Option value="week">This Week</Option>
          <Option value="month">This Month</Option>
          <Option value="year">This Year</Option>
        </Select>
      </div>

      {/* Notification-specific stats */}
      <Row gutter={[16, 16]} className="mb-6">
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total Messages"
              value={extractNumber(totalMessages?.value || "0")}
              precision={0}
              valueStyle={{ 
                // color: totalMessages?.change > 0 ? '#3f8600' : totalMessages?.change < 0 ? '#cf1322' : '#000000' 
              }}
            //   prefix={totalMessages?.change > 0 ? <ArrowUpOutlined /> : totalMessages?.change < 0 ? <ArrowDownOutlined /> : null}
              suffix={totalMessages?.change ? `${Math.abs(totalMessages.change)}%` : ''}
            />
            <div className="text-xs text-gray-500 mt-1">
              {totalMessages?.comparison || 'No comparison data'}
            </div>
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Delivery Rate"
              value={extractNumber(deliveryRate?.value || "0")}
              precision={1}
              valueStyle={{ 
                color: extractNumber(deliveryRate?.value || "0") > 90 ? '#3f8600' : 
                       extractNumber(deliveryRate?.value || "0") > 70 ? '#faad14' : '#cf1322' 
              }}
              suffix="%"
            />
            <div className="text-xs text-gray-500 mt-1">
              {deliveryRate?.comparison || 'No comparison data'}
            </div>
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total Cost"
              value={extractNumber(totalCost?.value || "0")}
              precision={2}
              prefix="$"
              valueStyle={{ color: '#cf1322' }}
            />
            <div className="text-xs text-gray-500 mt-1">
              {totalCost?.period || 'This month'}
            </div>
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Active Triggers"
              value={activeTriggers?.value || "0 of 0"}
            />
            <div className="text-xs text-gray-500 mt-1">
              {activeTriggers?.status || 'Status unknown'}
            </div>
          </Card>
        </Col>
      </Row>

      {/* Channel Distribution */}
      <Card title="Message Channel Distribution" className="mb-6">
        <div className="space-y-4">
          <div>
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium">SMS</span>
              <span className="text-sm text-muted-foreground">
                {channelDistribution?.sms?.count || 0} ({channelDistribution?.sms?.percentage || '0%'})
              </span>
            </div>
            <Progress 
              percent={extractNumber(channelDistribution?.sms?.percentage || "0")} 
              strokeColor="#1890ff" 
            />
          </div>
          {/* <div>
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium">WhatsApp</span>
              <span className="text-sm text-muted-foreground">
                {channelDistribution?.whatsapp?.count || 0} ({channelDistribution?.whatsapp?.percentage || '0%'})
              </span>
            </div>
            <Progress 
              percent={extractNumber(channelDistribution?.whatsapp?.percentage || "0")} 
              strokeColor="#52c41a" 
            />
          </div> */}
        </div>
      </Card>
    </div>
  );
};

export default Statistics;